import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import { ALIMTALK_SEND_PAGE_NAME } from '../../views/alimtalk/send/history/constants';
import AlimtalkSendHistoryListWrap from '../../views/alimtalk/send/history/components/AlimtalkSendHistoryListWrap';

/**
 *  알림톡 발송 내역 (목록) 페이지
 */
const AlimtalkSendHistoryList = (): JSX.Element => {
  return (
    <PageTemplate pageName={ALIMTALK_SEND_PAGE_NAME.HISTORY_LIST}>
      <AlimtalkSendHistoryListWrap />
    </PageTemplate>
  );
};

export default AlimtalkSendHistoryList;
